import React, {useEffect, useState} from 'react';

import {FocusLayerSizeV2} from '@volkswagen-onehub/layer-manager';
import {Info} from '@vw-marketing/us-components';

import {StyledInfoToolTipContainer} from './styled';
import {useTranslations} from '../../hooks/use-translations';
import {useFeatureServices} from '../../hooks/use-feature-services';
import {InfoToolTipModal} from '../info-tool-tip-modal/InfoToolTipModal';

export const InfoToolTip = () => {
  const layerManager = useFeatureServices()['layer-manager'];
  const defaultContent = useTranslations().modals.modalBuildMyDealToolTip;

  const [isOpenInfo, setIsOpenInfo] = useState(false);

  const toggleInfoModal = (isOpen?: boolean) => {
    setIsOpenInfo(isOpen || !isOpenInfo);
  };

  useEffect(() => {
    if (isOpenInfo) {
      layerManager.openFocusLayer(
        InfoToolTipModal,
        {
          title: defaultContent.title,
          information: defaultContent.description,
          handleInternalClose: toggleInfoModal.bind(null, false),
        },
        {
          size: FocusLayerSizeV2.A,
        },
      );
    }
  }, [isOpenInfo]);

  return (
    <StyledInfoToolTipContainer onClick={toggleInfoModal.bind(null, true)}>
      <Info variant="default" />
    </StyledInfoToolTipContainer>
  );
};
